import { makeRequest } from '../client'

export const createCustomer = async (data) =>
  makeRequest('customer', 'createCustomer', data);

export const getCustomers = async (restaurantId) =>
  makeRequest('customer', 'getCustomers', { restaurantId });

export const getCustomerByPhone = async (restaurantId, phone) =>
  makeRequest('customer', 'getCustomerByPhone', { restaurantId, phone });

export const getCustomerPoints = async (customerId) =>
  makeRequest('customer', 'getCustomerPoints', { customerId });

export const getCustomerDetails = async (customerId, options = {}) =>
  makeRequest('customer', 'getCustomerDetails', { customerId, ...options });

export const getMarketingPreference = (restaurantId, customerId) =>
  makeRequest('customer', 'getMarketingPreference', { restaurantId, customerId });

export const setMarketingPreference = (restaurantId, customerId, allowed) =>
  makeRequest('customer', 'setMarketingPreference', { restaurantId, customerId, allowed });
